import { Input } from "antd";


const CommonInput = ({
  name,
  prefix=null,
  type,
  value="",
  onChange = () => {},
  onInput = () => {},
  placeholder,
  disabled=false
}) => {
  return (
    <Input
    autoComplete={false}
    prefix={prefix}
      name={name}
      disabled={disabled}
      placeholder={placeholder}
      type={type}
      value={value}
      onChange={onChange}
      onInput={onInput}
      className="bg-dynmaicBg h-10 text-dynmaicText border-none hover:bg-darkbg3 hover:shadow-none focus:shadow-none shadow-none focus:bg-darkbg3 rounded-full"
    />
  );
};

export default CommonInput;
